<script lang="ts">
    import Review from "./Reviews.svelte";
    import ProductImage from "./ProductImage.svelte";
    import {platform, promotedByPersonalizationProducts, Reporting} from "../store/store";
    import Price from "./Price.svelte";
    import {getProductPageID} from "@fast-simon/common"
    import {TranslationUtil, TranslationUtilProvider} from "@fast-simon/translation_providers"
    import {ImageRatio} from "../@types/imageRatio";
    import AddToCart from "./AddToCart.svelte";
    import {ServerProduct} from "../@types/product";
    import {createGTagEventObj} from "../utils/createGTagEventObj";


    export let id: string
    export let name: string
    export let imgSize: string
    export let currency: string
    export let price: string
    export let previousPrice: string
    export let minPrice: number
    export let imageSrc: string
    export let review: number
    export let reviews_count: number
    export let path: string
    export let vertical: boolean
    export let transformPX: string
    export let i: number
    export let productsPerPage: number
    export let imgRatio: ImageRatio
    export let productsWithReviews: boolean
    export let onHoverCarousel: boolean;
    export let addToCart: boolean;
    export let product: ServerProduct;
    export let recSource: number
    export let title: string = ''
    let isHover = false;

    const computedPath = (() => {
        const isLangifySite = TranslationUtil?.getCurrentProvider() === TranslationUtilProvider.LANGIFY;
        return !isLangifySite
            ? path
            : TranslationUtil.getProductUrl(TranslationUtilProvider.LANGIFY, path) ?? "";
    })();

    function onClick() {
        const gtagProduct = {
            id: id,
            l: name,
            v: product.v,
            c: currency,
            p: price
        }
        const isPersonalizedProduct = $promotedByPersonalizationProducts?.includes(Number(id));
        console.log({
            id, // destination product
            pos: i + 1, // position of the product in the list
            from_product: getProductPageID($platform), // src product
            rec: isPersonalizedProduct ? 1 : undefined,
            rec_src: recSource
        });
        $Reporting.Recommendations.reportProductClicked({
            id, // destination product
            pos: i + 1, // position of the product in the list
            from_product: getProductPageID($platform), // src product
            rec: isPersonalizedProduct ? 1 : undefined,
            rec_src: recSource,
            gtag_product_items: createGTagEventObj({products: [gtagProduct as ServerProduct], ids: [id?.toString()], position: i + 1, listTitle: title})
        }).then(() => {
            $Reporting.navigate(computedPath, "");
        }).catch(e => {
            console.error(e);
            $Reporting.navigate(computedPath, "");
        });
    }

    const onMouseOver = () => {
        isHover = true;
    }

    const onMouseLeave = () => {
        isHover = false;
    }

</script>

<a class="product-container fs-recommendation-product-container fs-upsell-cross-sell-product" href={computedPath}
   on:click|preventDefault={onClick} data-id={id} on:mouseover={onMouseOver} on:focus={onMouseOver}
   on:blur={onMouseLeave} on:mouseleave={onMouseLeave}
   style={vertical ? `transform: translateY(${transformPX}px)` : `transform: translateX(${transformPX}px)`}>
    <ProductImage productsPerPage={productsPerPage} alt={name} src={imageSrc} imageSize={imgSize} imgRatio={imgRatio}
                  vertical={vertical} id={id} onHoverCarousel={onHoverCarousel} isProductHover={isHover} path={computedPath} />
    {#if addToCart}
        <AddToCart id={id} product={product}/>
    {/if}
    <span class="name fs-recommendation-product-name-wrapper" style={`inline-size: ${imgSize}px`}>{name}</span>
    <Price price={price} currency={currency} previousPrice={previousPrice} minPrice={minPrice} imgSize={imgSize}/>
    {#if review > 0}
        <span class="review"><Review review={review} reviews_count={reviews_count} id={id+i}/></span>
    {:else if productsWithReviews}
        <div class="review-blank"></div>
    {/if}

</a>


<style>

    a {
        color: unset;
        text-decoration: unset;
    }

    a:visited {
        color: unset;
        text-decoration: unset;
    }

    a:hover {
        color: unset;
        text-decoration: unset;
    }

    a:active {
        color: unset;
        text-decoration: unset;
    }

    .product-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 10px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    }

    .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
    }

    .review {
        color: #939597;
    }

    .review-blank {
        height: 19.4px;
        min-height: 19.4px;
    }

</style>